import { render, staticRenderFns } from "./Senderinfo.vue?vue&type=template&id=6eaafd15&scoped=true"
import script from "./Senderinfo.vue?vue&type=script&lang=js"
export * from "./Senderinfo.vue?vue&type=script&lang=js"
import style0 from "./Senderinfo.vue?vue&type=style&index=0&id=6eaafd15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaafd15",
  null
  
)

export default component.exports